import { render, staticRenderFns } from "./ResetPasswordEmailForm.vue?vue&type=template&id=da8e2746&scoped=true"
import script from "./ResetPasswordEmailForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8e2746",
  null
  
)

export default component.exports